var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { DotsVerticalIcon, IconButton, translate, } from '@lucidlink/uicore';
export const FilespaceDetailsMenuTrigger = ({ className, isFloatingBoxActive: _isFloatingBoxActive, ...triggerProps }) => {
    return (_jsx(IconButton, { ...triggerProps, "aria-label": translate('open filespace menu'), className: className, "data-testid": "filespace-details-menu-trigger", Icon: DotsVerticalIcon, kind: "ghost", onClick: (e) => {
            triggerProps.onClick(e);
        }, onKeyDown: (e) => {
            triggerProps.onKeyDown(e);
        }, size: "medium" }));
};
_react_refresh_temp_1 = FilespaceDetailsMenuTrigger;
$RefreshReg$(_react_refresh_temp_1, "FilespaceDetailsMenuTrigger");
